import { ASSETS_NAMES } from '@/shared/utils/constants';
import { IonCol, IonIcon, IonRow } from '@ionic/react';
import styles from './TransactionListItem.module.css';
import { Transaction } from '@/types/crypto';
import { getTransactionStateDisplayValue, getTransactionTypeDisplayValue } from '@/shared/helpers/transactions';
import { getShortDateTimeString } from '@/shared/helpers/formatters';
import { getCryptoAmount } from '@/shared/helpers/crypto';

type Props = {
  transaction: Transaction;
};

const TransactionListItem: React.FC<Props> = ({ transaction }) => {
  return (
    <div className={styles.rowItem}>
      <IonRow class="ion-align-items-center; ion-justify-content-center">
        <IonCol size="2" className={styles.coinColumn}>
          <IonIcon className={styles.coinIcon} size="large" src={`assets/icons/${transaction.assetId}.svg`} />
          {ASSETS_NAMES[transaction.assetId]}
        </IonCol>
        <IonCol size="2" className={styles.columnItem}>
          {getTransactionTypeDisplayValue(transaction.transactionType)}
        </IonCol>
        <IonCol size="3" className={styles.columnItem}>
          <span className={styles.dateWidth}>{getShortDateTimeString(transaction.createdAt)}</span>
        </IonCol>
        <IonCol size="3" className={styles.columnItem} class="ion-text-end">
          {getCryptoAmount(transaction.amount, transaction.assetId)}
        </IonCol>
        <IonCol size="2" className={styles.columnStatus} class="ion-text-end">
          {getTransactionStateDisplayValue(transaction.transactionState)}
        </IonCol>
      </IonRow>
    </div>
  );
};

export default TransactionListItem;
